export default __webpack_public_path__ + "static/media/onboardingBg.21dab7f0.png";